<div class="dashboard container-fluid">

  <div class="row">
    <!-- Contracts Card -->
    <div class="col-sm-12 col-lg-6 col-xl-4">
      <app-card [config]="cards.contracts"> </app-card>
    </div>

    <!-- Assets Card -->
    <div class="col-sm-12 col-lg-6 col-xl-4">
      <app-card [config]="cards.assets"> </app-card>
    </div>

    <!-- Tickets Card -->
    <div class="col-sm-12 col-lg-12 col-xl-4">
      <app-card [config]="cards.tickets"> </app-card>
    </div>
  </div>

  <div class="container-grid">
    <!-- Contracts Chart Card -->
    <div class="contractsChart"><app-card [config]="cards.contractsChart"> </app-card></div>
    <!-- Assets Chart Card -->
    <div class="assetsChart"><app-card [config]="cards.assetsChart"> </app-card></div>
    <!-- Locations Map Card -->
    <div class="locationsMap"><app-card [config]="cards.locationsMap"> </app-card></div>
  </div>

</div>

